import { UserGeneratedConfigService } from 'app/config/user_generated_config.service';
import { HeatmapDataRequester } from 'app/map/services/heatmap/HeatmapDataRequester';
import {
    GetWithLocationFilterArgs,
    ImsTimeCollection,
} from 'app/shared/collections/time/ims_time_collection.factory';
import { CachedEventRegistry } from 'app/shared/events/cached_event_registry';
import { VectorHeatMapContext } from 'app/views/view_types/view_utils';
import { LimitChunkedHeatmapDataRequester } from './LimitChunkedHeatmapDataRequester';
import { TimeChunkedHeatmapDataRequester } from './TimeChunkedHeatmapDataRequester';
import { ConfigService } from 'app/config/config.service';

export type HeatMapInclusionArray = { imsType: string; columnName: string }[];

export class HeatmapDataRequesterFactory {
    private _userGeneratedConfigService: UserGeneratedConfigService;

    constructor(userGeneratedConfigService: UserGeneratedConfigService) {
        this._userGeneratedConfigService = userGeneratedConfigService;
    }

    create(
        columnName: string,
        filterArgs: GetWithLocationFilterArgs,
        timeCollection: ImsTimeCollection,
        hoursRequested: number,
        maxPoints: number,
        eventRegistry: CachedEventRegistry,
        vectorHeatMapContext: VectorHeatMapContext | null,
        configService: ConfigService,
    ): HeatmapDataRequester {
        const imsType = timeCollection.getImsType();
        const inclusionList = configService.timeChunkedHeatMapDataRequesterInclusionlist || [];

        // The inclusion list is small so this should be fine...
        if (
            inclusionList.find((item) => item.imsType === imsType && item.columnName === columnName)
        ) {
            // use the time chunking
            return new TimeChunkedHeatmapDataRequester(
                columnName,
                filterArgs,
                timeCollection,
                hoursRequested,
                eventRegistry,
                maxPoints,
                this._userGeneratedConfigService.configData.heatMapChunkSize,
                configService.heatMapDatabaseFailLimitPerChunk,
                configService.heatMapDatabaseFailLimit,
                vectorHeatMapContext,
                configService.initialHeatMapTimeChunkSizeSeconds,
                configService.heatMapTimeChunkSizeSecondsAdjustment,
            );
        } else {
            return new LimitChunkedHeatmapDataRequester(
                columnName,
                filterArgs,
                timeCollection,
                hoursRequested,
                eventRegistry,
                maxPoints,
                this._userGeneratedConfigService.configData.heatMapChunkSize,
                configService.heatMapDatabaseFailLimitPerChunk,
                configService.heatMapDatabaseFailLimit,
                vectorHeatMapContext,
            );
        }
    }
}
